import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customDateTime',
})
export class CustomDateTimePipe extends DatePipe implements PipeTransform {
  transform(
    item :any,
    format :string = 'medium',
    timezone :string = 'America/Denver',
  ) :any {
    return super.transform(item, format, timezone);
  }
}
